export default __webpack_public_path__ + "static/media/coronavirus_orange.66cdfe6f.png";